<template>
  <div>
    <div class="block">
      <ul class="todo-list">
        <div class="has-text-centered" v-if="!items.length">
          There are no todos
        </div>
        <li v-for="(item, index) in items" v-bind:key="index" v-bind:class="{slim: slim}">
          <div class="columns is-vcentered is-mobile">
            <div class="column">
              <b-checkbox v-model="item.checked">
                <span v-bind:class="{ 'text-striked':item.checked  }">{{ item.title }}</span>
              </b-checkbox>
            </div>
            <div class="column is-narrow has-text-right">
              <a @click="deleteItem(index)" class="button is-danger">
                <i class="fas fa-times"></i>
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="block">
      <div class="field has-addons">
        <div class="control is-expanded">
          <input type="text" class="input" v-model="todoTitle" placeholder="Todo..."
           v-on:keyup.13="addItem()"
          >
        </div>
        <div class="control">
          <button class="button is-primary" @click.prevent="addItem()">Add</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    slim: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      todoTitle: '',
      todos: this.items,
    };
  },
  methods: {
    addItem() {
      if (this.todoTitle.length > 0) {
        this.todos.push({
          title: this.todoTitle,
          checked: false,
        });
        this.todoTitle = '';
      }
    },
    deleteItem(index) {
      this.todos.splice(index, 1);
    },
  },
};
</script>

<style scoped>
  .text-striked {
    text-decoration: line-through;
    font-style: italic;
  }

  .todo-list li.slim {
    border-left: none;
    border-right: none;
  }

  .todo-list li {
    background: #f3f3f4;
    border-left: 6px solid #e7eaec;
    border-right: 6px solid #e7eaec;
    border-radius: 4px;
    margin-bottom: 14px;
    padding-left: 5px;
    padding-right: 5px;
    color: inherit;
  }
</style>
